import { styled } from '@mui/material';

export const ChkScreenReaderOnly = styled('div')({
  width: '1px',
  height: '1px',
  padding: '0',
  margin: '-1px',
  overflow: 'hidden',
  border: 0,
});
